import { useCartStyles } from './Cart.styles';
import CartButtonRow from './buttons/CartButtonRow/CartButtonRow';
import AccessorySection from './sections/AccessorySection/AccessorySection';
import { useCart } from '../../contexts/CartContext/CartContext.hooks';
import LineCard from './Cards/Line/LineCard';

const Cart = () => {
    const styles = useCartStyles();

    const { cart } = useCart();

    return (
        <div className={styles.cartContainer}>
            {cart.lineItems.map((x) => (
                <div key={`${x.lineNumber}-cart-section`}>
                    <LineCard key={`${x.lineNumber}-line-card`} item={x} />
                </div>
            ))}

            <AccessorySection />

            <CartButtonRow />
        </div>
    );
};

export default Cart;
